// WorkshopEntryDialog.jsx
import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';

const EntradaTallerForm = ({ open, onClose }) => {
  const [formData, setFormData] = useState({
    responsable: '',
    producto: '',
    estado: '',
    descripcion: '',
    fechaIngreso: '',
    fechaSalida: '',
    notas: '',
  });

  const handleChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };

  const handleSubmit = () => {
    console.log('Datos del taller:', formData);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Entrada al Taller</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField
              placeholder="Producto a revisar"
              fullWidth
              value={formData.producto}
              onChange={handleChange('producto')}
            />
          </Grid>
          <Grid size={12}>
            <FormControl fullWidth>
              <Select
                value={formData.responsable}
                onChange={handleChange('responsable')}
                placeholder="Responsable"
              >
                <MenuItem value="manuel">Manuel Armando Iturbides</MenuItem>
                <MenuItem value="otro">Otro</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid size={12}>
            <TextField
              placeholder="Descripción del problema"
              multiline
              fullWidth
              value={formData.descripcion}
              onChange={handleChange('descripcion')}
            />
          </Grid>
          <Grid size={6}>
            <TextField
              placeholder="Fecha de ingreso"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={formData.fechaIngreso}
              onChange={handleChange('fechaIngreso')}
            />
          </Grid>
          <Grid size={6}>
            <TextField
              placeholder="Fecha estimada de salida"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={formData.fechaSalida}
              onChange={handleChange('fechaSalida')}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              placeholder="Notas adicionales"
              fullWidth
              value={formData.notas}
              onChange={handleChange('notas')}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant='outlined'>Cancelar</Button>
        <Button onClick={handleSubmit} variant="contained" color="primarybutton" sx={{fontWeight:"bold"}}>
          Registrar entrada
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EntradaTallerForm;
